import HBMessage from "@/components/HBMessage";
import HBConfirm from "@/components/HBModal/confirm";
import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import { goGdMerge } from "@/pageComponents/GdMerge";
import { getGrocery } from "@/services";
import { Checkbox } from "antd";
import { template } from "lodash";
import { isGdMerged } from "./gaoding";
import { huabanArtHost } from "./host";
import imageUrl from "./imageUrl";
import { checkLogin, openBindTelModal } from "./open";
import useReq from "./useReq";

export enum AIFuncEnum {
  distinct = "distinct",
  expand = "expand",
  cut = "cut",
  remove = "remove",
  filter = "filter",
  repaint = "repaint",
}

/**缩小尺寸，输入宽高，缩放使其宽度和高度都不超过2000，并返回缩放后的宽度 */
function scaleDimensions(width, height, maxDimension = 2000) {
  // 检查是否需要缩放
  if (width <= maxDimension && height <= maxDimension) {
    return width; // 如果宽度和高度都不超过2000，则直接返回原始宽度
  }

  // 计算缩放比例
  const widthRatio = maxDimension / width;
  const heightRatio = maxDimension / height;
  const scaleRatio = Math.min(widthRatio, heightRatio);

  // 计算并返回缩放后的宽度
  return Math.round(width * scaleRatio);
}

export const goAiEditPage = async ({
  pin,
  conf,
}: {
  pin: IPin;
  conf: ToolType;
}) => {
  const user = await checkLogin({
    source_location: `${conf.name}`,
  });

  if (!user?.user_id) {
    return;
  }

  await openBindTelModal();

  if (!(await checkAiContentDisclaimer())) {
    return;
  }

  // const scaleWidth = scaleDimensions(pin.file.width, pin.file.height);

  // 临时统一采用1200宽度尺寸的图片
  let resource_url = imageUrl(pin.file, { origin: true }) + "_fw1200png";

  // if (scaleWidth === pin.file.width) {
  //   // 未超出尺寸，返回原图
  //   resource_url = imageUrl(pin.file, { origin: true });

  //   // tiff 类型不支持，需要转成png
  //   if (pin.file.type === "image/tiff" || pin.file.type === "image/tif") {
  //     resource_url = resource_url + "_png";
  //   }
  // } else {
  //   // 超出（2000*2000）尺寸要求，进行作图返回
  //   resource_url = imageUrl(pin.file, { width: scaleWidth, webp: false });
  // }

  const imgParam = template(conf.imgParam)({
    imgUrl: encodeURIComponent(resource_url),
  });
  const url = `https://${huabanArtHost}${conf.path}?${conf.params}&${imgParam}`;

  if (!isGdMerged(user)) {
    // window.open(`/gdmerge?redirect_uri=${url}`);
    goGdMerge({
      redirectUri: url,
    });
  } else {
    window.open(url);
  }
};
/**
 * 设置内容免责声明确认
 */
function setAllowedState(flag: boolean) {
  localStorage.setItem(
    LOCAL_STORAGE_KEY.HB_AI_TOOLS_CONTENT_DISCLAIMER,
    String(flag)
  );
}

/**获取是否已经同意免责声明状态 */
function getAllowedState() {
  return (
    localStorage.getItem(LOCAL_STORAGE_KEY.HB_AI_TOOLS_CONTENT_DISCLAIMER) ===
    "true"
  );
}

/**
 * 内容免责声明确认
 *
 * 确认状态存在localStorage中存储
 *
 * 确认过一次就不用再弹确认框
 *
 * 没有确认过，则弹确认框
 *
 */
export async function checkAiContentDisclaimer() {
  // 从本地获取是否已经同意过
  const hasAllowed = getAllowedState();

  if (hasAllowed) {
    return Promise.resolve(true);
  } else {
    let hasAllowed = false;

    return new Promise((resolve, reject) => {
      const confirmDialog = HBConfirm.open({
        title: "提示",
        visibleControl: true,
        className: "black-theme",
        content: (
          <div data-gd-expose="dialog_expose" data-dialog-title="内容免责声明">
            花瓣致力于帮助创作者激发灵感，不得通过以上功能侵犯他人合法权益，否则由此产生的法律后果由您自行承担。
            <Checkbox
              className="hb-checkbox"
              style={{ marginTop: 25 }}
              onChange={(e) => {
                hasAllowed = e.target.checked;
              }}
            >
              请勾选并同意
              <a
                className="primary-text-btn"
                href="https://huaban.com/about/disclaimer?activeKey=0"
                target="_blank"
                style={{ fontWeight: 500 }}
              >
                《花瓣用户协议》
              </a>
            </Checkbox>
          </div>
        ),
        okText: "同意",
        okType: "primary",
        okButtonProps: {
          style: { width: 88 },
          "data-gd-click": "button_click",
          "data-button-name": "同意",
          "data-content-source": "内容免责声明",
        },
        cancelType: "default",
        cancelButtonProps: {
          style: { width: 88, marginRight: 8 },
        },
        closable: true,
        hideIcon: true,
        onOk: () => {
          if (hasAllowed) {
            setAllowedState(hasAllowed);
            resolve(true);
            confirmDialog.destroy();
          } else {
            HBMessage.info("请先阅读并勾选同意《花瓣用户协议》");
          }
        },
        onCancel() {
          resolve(false);
          confirmDialog.destroy();
        },
      });
    });
  }
}

export type ToolType = {
  name: string;
  params: string;
  path: string;
  imgParam: string;
  icon: string;
  rightTag?: IGroceryUploadFile[];
  abValue?: string;
  abVariable?: string;
};
export function useAITools() {
  // 获取 杂货铺配置的 ai工具列表
  const { data } = useReq(async () => {
    const [conf, abValue] = await Promise.all([
      getGrocery<{
        toolLink: ToolType[];
        abTest: {
          ab: string;
          toolLink: ToolType[];
        }[];
      }>("ai_tools_conf"),
      "string_2",
    ]);

    if (!conf) {
      return [];
    }

    let toolLink = conf.toolLink;

    // 匹配AB实验 abValue 不为空
    if (conf.abTest.length && abValue) {
      const abToolLink = (
        conf.abTest.find((item) => item.ab === abValue)?.toolLink || []
      ).map((opt) => ({
        ...opt,
        // 用于跳转的时候添加不同的域名
        abValue, // AB实验变量的值
        abVariable: "AI_Redirect_path", // AB实验变量
      }));
      toolLink = abToolLink?.length ? abToolLink : conf.toolLink;
    }

    return toolLink || [];
  });

  return data || [];
}

export function getEditorUrlByTemplateId(templateId: string) {
  return `https://${huabanArtHost}/editor/canvas?id=${templateId}`;
}
